import dayjs from "dayjs";

const avg = (a) => (a.length ? a.reduce((x, y) => x + y, 0) / a.length : null);
const lastMonths = (n) => Array.from({ length: n }, (_, i) => dayjs().subtract(n - 1 - i, "month").format("YYYY-MM"));

export const triggerMood = (s) => s.moodBefore ?? s.moodNow;

export function themeGrid(sessions, months = 6) {
  const cols = lastMonths(months);
  const rows = {};
  sessions.filter((s) => s.triggerTheme && triggerMood(s) != null).forEach((s) => {
    const r = (rows[s.triggerTheme] ||= { theme: s.triggerTheme, all: [], by: {} });
    r.all.push(triggerMood(s));
    (r.by[s.timestamp.slice(0, 7)] ||= []).push(triggerMood(s));
  });
  const list = Object.values(rows)
    .map((r) => ({ theme: r.theme, n: r.all.length, avg: avg(r.all), cells: cols.map((m) => (r.by[m] ? { v: avg(r.by[m]), n: r.by[m].length } : null)) }))
    .sort((a, b) => b.n - a.n || a.avg - b.avg)
    .slice(0, 8);
  const hardest = [...list].filter((r) => r.n >= 2).sort((a, b) => a.avg - b.avg)[0];
  return { cols, rows: list, hardest };
}

export const recoveryMins = (s) => (s.recoveredAt ? Math.max(0, (new Date(s.recoveredAt) - new Date(s.timestamp)) / 60000) : null);

export function recoveryStats(sessions, months = 6) {
  const timed = sessions.filter((s) => recoveryMins(s) != null);
  const trend = lastMonths(months).map((m) => {
    const v = timed.filter((s) => s.timestamp.startsWith(m)).map(recoveryMins);
    return { m, label: dayjs(m + "-01").format("MMM"), mins: v.length ? Math.round(avg(v) * 10) / 10 : null, n: v.length };
  });
  const withData = trend.filter((t) => t.mins != null);
  let message = "";
  if (withData.length >= 2) {
    const [a, b] = [withData[withData.length - 2], withData[withData.length - 1]];
    const d = Math.round((a.mins - b.mins) * 10) / 10;
    message = d > 0 ? `You're settling ${d} min faster in ${b.label} than in ${a.label}. Your nervous system is learning.`
      : d < 0 ? `Settling took a little longer in ${b.label} — harder months happen, and you still found your way back.`
      : `Your recovery time is holding steady.`;
  }
  return { count: timed.length, avg: timed.length ? Math.round(avg(timed.map(recoveryMins)) * 10) / 10 : null, trend, message };
}

export const fmtMins = (m) => (m == null ? "—" : m < 60 ? `${m < 10 ? m.toFixed(1) : Math.round(m)} min` : `${Math.floor(m / 60)} h ${Math.round(m % 60)} min`);
